
import { useLiveQuery } from "dexie-react-hooks";
import { useEffect, useState } from "react";
import { db } from "~/db/db";
import { prepareData } from "~pages/ResearchManagement/helpers/searchHelpers";
import { useGetPesquisasClientes } from "~pages/ResearchManagement/hooks/useResearchManagementRequests";

const usePesquisasCampoClientes = ({ filters = {}, clienteId = 0, tipo = "todos", skip, take }) => {
  const titulos = useLiveQuery(async () => {
    const obj = {};
    const today = new Date();

    await db.pesquisaCampoCliente
    .filter(e => {
      const outPeriod = new Date(e.dataInicio) > today || new Date(e.dataFim) < today;
      const inPeriod = new Date(e.dataInicio) <= today && new Date(e.dataFim) >= today;

      return (clienteId ? e.clienteId == clienteId : true) &&
      (tipo == "historico" ? (e.dataResposta || outPeriod) : true) &&
      (tipo == "ativos" ? (!e.dataResposta && inPeriod) : true)
    })
    .each(item => {
      if(!obj[item.title])
        obj[item.title] = {
          title: item.title,
          id: item.pesquisaCampoId
        }
    });

    return Object.values(obj);
  });

  const filterByPeriod = ({ period, date, todayDate = new Date() }) => {
    if (!period) return true;

    const today = todayDate ?? new Date();
    const pesquisaDate = new Date(date);
    today.setHours(0, 0, 0, 0);
    pesquisaDate.setHours(0, 0, 0, 0);

    const daysAgoMap = {
      last1days: 1,
      last3days: 3,
      last5days: 5,
      last7days: 7,
      last14days: 14,
      last30days: 30,
      last60days: 60,
      last90days: 90,
    };

    const daysAgo = daysAgoMap[period];
    if (!daysAgo) return true;

    const differenceInTime = today - pesquisaDate;
    const differenceInDays = differenceInTime / (1000 * 60 * 60 * 24);

    if (period === 'last1days') {
      return differenceInDays === 0;
    }

    return differenceInDays >= 0 && differenceInDays <= daysAgo;
  };

const queryPesquisa = async ({ }) => {
  const { searchText, status, period, title, validityPeriod } = filters;
  const search = searchText?.toLowerCase() ?? "";
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const getDataParaFiltro = (e) => {
    return e.dataResposta || e.dataInicio;
  };

  return await db.pesquisaCampoCliente
    .filter(e => {
      const outPeriod = new Date(e.dataInicio) > today || new Date(e.dataFim) < today;
      const inPeriod = new Date(e.dataInicio) <= today && new Date(e.dataFim) >= today;

      return (
        (tipo === "historico" ? (e.dataResposta || outPeriod) : true) &&
        (tipo === "ativos" ? (!e.dataResposta && inPeriod) : true) &&
        (clienteId ? e.clienteId == clienteId : true) &&
        (validityPeriod === "Todos" ||
          (validityPeriod === "Sim" && inPeriod) ||
          (validityPeriod === "Não" && outPeriod)) &&
        (search ? e.toFilterName?.includes(search) : true) &&
        (title && title !== "Todas" ? e.pesquisaCampoId == title : true) &&
        (status === "Todos" || e.status == status) &&
        (period && period !== "Todos"
          ? filterByPeriod({ period, date: getDataParaFiltro(e), todayDate: today })
          : true)
      );
    });
};


  const pesquisasCampoCliente = useLiveQuery(async () => {
    let result = await queryPesquisa({});

    return await result.sortBy('data');
  }, [filters, skip])

  const [pesquisasCampoClienteAll, setPesquisasCampoClienteAll] = useState([]);

  useEffect(() => {
    const fetchPesquisas = async () => {
      let query = await queryPesquisa({});
      const result = [];
      await query.each(e => result.push(e));

      setPesquisasCampoClienteAll(result);
    }

    fetchPesquisas();
  }, []);

  const updatePesquisaData = async ({data}) => {
    if(data && Array.isArray(data)) {
      await db.pesquisaCampoCliente.bulkPut(data);
    }
  }

  const {data: queryData, isFetching} = useGetPesquisasClientes();

  useEffect(() => {
    if (queryData) {
      const { dados } = prepareData(queryData);
      updatePesquisaData({data: dados})
    }
  }, [queryData]);

  return {
    titulos,
    pesquisasCampoCliente,
    pesquisasCampoClienteAll,
    carregando: isFetching
  };
}

export default usePesquisasCampoClientes;